import { Typography } from "antd/lib";
import { ReactElement, useEffect } from "react";
import { useSelector } from "react-redux";
import { LoginLayout } from "../../../layouts/LoginLayout/LoginLayout";
import { useAppDispatch } from "../../../store/reduxHooks";
import { SELECT_TYPE_POSITION } from "../../../store/selectors/authSliceLoginSelector";
import { TYPE_POSITION } from "../../../store/slice/authSliceLogin/authSliceLogin";
import { RegistrationAgentForm } from "../RegistrationAgentForm/RegistrationAgentForm";
import { SendRegisterInstruction } from "../SendRegisterInstruction/SendRegisterInstruction";

import classes from "./RegisterAgent.module.css";

const { Title } = Typography;

export function RegistrationAgent(): ReactElement {
  const userTypePosition = useSelector(SELECT_TYPE_POSITION);
  const dispatch = useAppDispatch();
  useEffect(() => {
    return () => {
      dispatch(TYPE_POSITION("DEFAULT"));
    };
  }, []);

  if (userTypePosition === "MESSAGE_EMAIL") {
    return (
      <LoginLayout classNameMain="classNameMainRegCenter">
        <SendRegisterInstruction />
      </LoginLayout>
    );
  }

  return (
    <LoginLayout>
      <Title className={classes.regHeaderName} level={1}>
        Регистрация
      </Title>
      <RegistrationAgentForm />
    </LoginLayout>
  );
}
